/* RESPONSIBLE TEAM: team-conversational-knowledge */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  attrs: {
    // Map relationship keys
    app: { key: 'app_id' },
    createdBy: { key: 'created_by_id' },
    reviewer: { key: 'reviewer_id' },
  },

  // Transform the API response to include the metadata fields at the top level
  normalize(typeClass: any, hash: any) {
    // If the API response has individual metadata fields at the top level,
    // consolidate them into the suggestionMetadata object
    if (hash) {
      let metadata: any = {};

      // Extract metadata fields from the top level
      if (hash.topic_name_list) {
        metadata.topic_name_list = hash.topic_name_list;
        delete hash.topic_name_list;
      }
      if (hash.subtopics) {
        metadata.subtopics = hash.subtopics;
        delete hash.subtopics;
      }
      if (hash.action_params) {
        metadata.action_params = hash.action_params;
        delete hash.action_params;
      }
      if (hash.mock_response) {
        metadata.mock_response = hash.mock_response;
        delete hash.mock_response;
      }
      if (hash.example_queries) {
        metadata.example_queries = hash.example_queries;
        delete hash.example_queries;
      }
      if (hash.conversation_ids) {
        metadata.conversation_ids = hash.conversation_ids;
        delete hash.conversation_ids;
      }
      if (hash.sampled_conversation_ids) {
        metadata.sampled_conversation_ids = hash.sampled_conversation_ids;
        delete hash.sampled_conversation_ids;
      }
      if (hash.guidance_id) {
        metadata.guidance_id = hash.guidance_id;
        delete hash.guidance_id;
      }
      // Only set suggestionMetadata if we have metadata fields
      if (Object.keys(metadata).length > 0) {
        hash.suggestion_metadata = metadata;
      }
    }

    return this._super(typeClass, hash);
  },
});
